var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSeesaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.001 510.001",
    height: 512,
    viewBox: "0 0 510.001 510.001",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.467,
    x2: 264.775,
    y1: 330.571,
    y2: 471.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#a26c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.49,
    x2: 319.49,
    y1: 421.907,
    y2: 313.907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42210b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210b"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#b6d600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#acc900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#9ab400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.73,
    x2: 202.221,
    xlinkHref: "#lg1",
    y1: 331.982,
    y2: 383.473
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.897 -.443 .443 .897 -337.035 197.599)",
    gradientUnits: "userSpaceOnUse",
    x1: 301.321,
    x2: 316.931,
    xlinkHref: "#lg2",
    y1: 251.82,
    y2: 251.82
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.897 -.443 .443 .897 -337.035 197.599)",
    gradientUnits: "userSpaceOnUse",
    x1: 726.174,
    x2: 741.784,
    xlinkHref: "#lg2",
    y1: 251.82,
    y2: 251.82
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.897 -.443 .443 .897 -337.035 197.599)",
    gradientUnits: "userSpaceOnUse",
    x1: 519.856,
    x2: 519.856,
    xlinkHref: "#lg3",
    y1: 263.018,
    y2: 323.313
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.917,
    x2: 288.572,
    y1: 260.573,
    y2: 247.678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.788,
    x2: 324.333,
    xlinkHref: "#lg2",
    y1: 262.058,
    y2: 262.058
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.053,
    x2: 194.077,
    xlinkHref: "#lg2",
    y1: 274.641,
    y2: 163.665
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.554,
    x2: 230.617,
    y1: 289.142,
    y2: 200.205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.583,
    x2: 272.987,
    xlinkHref: "#lg3",
    y1: 209.171,
    y2: 242.575
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.959,
    x2: 405.454,
    xlinkHref: "#lg1",
    y1: 296.414,
    y2: 390.522
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.213,
    x2: 336.774,
    xlinkHref: "#lg1",
    y1: 332.825,
    y2: 377.111
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.625 389.567c-4.962 3.617-6.877 9.503-4.792 14.822 4.121 10.513 14.613 18.605 27.845 20.608 66.664 10.093 143.929 15.867 226.322 15.867s159.659-5.774 226.322-15.867c13.232-2.003 23.724-10.095 27.845-20.608 2.085-5.318.17-11.205-4.792-14.822-69.006-50.297-156.357-77.839-246.557-77.557-.929.003-1.868.004-2.818.004s-1.889-.001-2.818-.004c-90.2-.281-177.551 27.26-246.557 77.557z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.17 404.387c-4.12 10.52-14.62 18.61-27.85 20.61-66.66 10.09-143.93 15.87-226.32 15.87-14.39 0-28.62-.18-42.66-.53l-77.07-77.07c-3.75-2.01-6.29-5.96-6.29-10.51v-5.56c0-7.22 2.18-13.93 5.93-19.5 37.62-10.44 77.16-15.81 117.27-15.69.93.01 1.87.01 2.82.01s1.89 0 2.82-.01h1.36c89.72 0 176.54 27.51 245.2 77.56 4.96 3.62 6.87 9.5 4.79 14.82z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m198.925 364.68h-58.031c-6.583 0-11.919-5.336-11.919-11.919v-5.569c0-19.316 15.659-34.975 34.975-34.975 19.316 0 34.975 15.659 34.975 34.975z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m73.63 312.101-18.259 9.009-24.325-49.298c-2.488-5.042-.417-11.146 4.625-13.634 5.042-2.488 11.146-.417 13.634 4.625z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.628 124.11-18.259 9.009-24.325-49.298c-2.488-5.042-.417-11.146 4.625-13.634 5.042-2.488 11.146-.417 13.634 4.625z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m499.965 131.652-466.191 230.026c-8.912 4.397-19.7.737-24.098-8.174l-7.815-15.839c-4.397-8.912-.737-19.7 8.174-24.098l466.191-230.025c8.912-4.397 19.7-.737 24.098 8.174l7.815 15.839c4.397 8.911.737 19.7-8.174 24.097z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m312.355 190.037-10.679-10.679c-2.157-2.249-4.476-4.344-6.938-6.267l-102.744 50.695-9.946 64.731 153.197-75.59z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m327.486 364.68h-144.972c-7.653 0-13.506-6.821-12.342-14.385l20.915-136.022c4.851-31.548 31.995-54.837 63.914-54.837 31.919 0 59.063 23.289 63.914 54.837l20.915 136.022c1.162 7.564-4.691 14.385-12.344 14.385z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 224.588,
    fill: "url(#SVGID_9_)",
    r: 48.526
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.829 350.295-15.168-98.648-46.916-46.916c-5.536-6.336-13.67-9.344-22.745-9.344-16.68 0-29.201 12.521-29.201 29.201 0 9.075 3.008 17.209 9.344 22.745l104.817 104.817c-.004-.612-.035-1.229-.131-1.855z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 224.588,
    fill: "url(#SVGID_11_)",
    r: 30.201
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m319.431 364.68h105.37c11.952 0 21.642-9.689 21.642-21.642v-10.111c0-35.073-28.432-63.506-63.506-63.506-35.073 0-63.506 28.433-63.506 63.506z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.17 364.68h58.031c6.583 0 11.919-5.336 11.919-11.919v-5.569c0-19.316-15.659-34.975-34.975-34.975-19.316 0-34.975 15.659-34.975 34.975z",
    fill: "url(#SVGID_13_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeesaw);
export default __webpack_public_path__ + "static/media/icon-seesaw.08b952e3e09e8ea0d4697c9582cce11b.svg";
export { ForwardRef as ReactComponent };